import { Component, Input } from '@angular/core';
import { InboundFaxStatus } from 'app/core/enums/inbound-fax-status.enum';
import { OutboundFax } from '../../../core/models/outbound-fax.model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FaxStatusPipe } from '../../pipes/fax-status.pipe';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';

@Component({
    selector: 'app-consult-note-received',
    templateUrl: './consult-note-received.component.html',
    styleUrls: ['./consult-note-received.component.scss'],
    imports: [RouterLink, DatePipe, FaxStatusPipe, CapitalizePipe]
})
export class ConsultNoteReceivedComponent {
  @Input() outboundFax: OutboundFax;
  inboundFaxStatuses = InboundFaxStatus;

  constructor() {}
}
